// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoteConfirmationPopup-module__font-s-10___DJFim {
  font-size: 10px !important;
}

.NoteConfirmationPopup-module__font-s-12___zZ0g5 {
  font-size: 12px !important;
}

.NoteConfirmationPopup-module__font-s-13___iAgV3 {
  font-size: 13px !important;
}

.NoteConfirmationPopup-module__font-s-14___pG2vN {
  font-size: 14px !important;
}

.NoteConfirmationPopup-module__font-s-15___e358v {
  font-size: 15px !important;
}

.NoteConfirmationPopup-module__font-s-16___vIOZv {
  font-size: 16px !important;
}

.NoteConfirmationPopup-module__font-s-18___A4wXA {
  font-size: 18px !important;
}

.NoteConfirmationPopup-module__font-s-20___MTjkC {
  font-size: 20px !important;
}

.NoteConfirmationPopup-module__font-s-22___Nzspu {
  font-size: 22px !important;
}

.NoteConfirmationPopup-module__font-s-28___XsexU {
  font-size: 28px !important;
}

.NoteConfirmationPopup-module__font-w-400___s3eM4 {
  font-weight: 400 !important;
}

.NoteConfirmationPopup-module__font-w-500___DbAqx {
  font-weight: 500 !important;
}

.NoteConfirmationPopup-module__font-w-600___Dobj8 {
  font-weight: 600 !important;
}

.NoteConfirmationPopup-module__font-w-700___w2HvD {
  font-weight: 700 !important;
}

.NoteConfirmationPopup-module__p-5___KFu5d {
  padding: 5px !important;
}

.NoteConfirmationPopup-module__p-12___TrLT_ {
  padding: 12px !important;
}

.NoteConfirmationPopup-module__p-16___9PbBY {
  padding: 16px !important;
}

.NoteConfirmationPopup-module__p-30___HDPLW {
  padding: 30px !important;
}

.NoteConfirmationPopup-module__p-b-0___i9aic {
  padding-bottom: 0 !important;
}

.NoteConfirmationPopup-module__p-b-5___KWYM4 {
  padding-bottom: 5px !important;
}

.NoteConfirmationPopup-module__p-b-10___SXh2Y {
  padding-bottom: 10px !important;
}

.NoteConfirmationPopup-module__p-b-12___Ny8Kn {
  padding-bottom: 12px !important;
}

.NoteConfirmationPopup-module__p-b-16___bowux {
  padding-bottom: 16px !important;
}

.NoteConfirmationPopup-module__p-b-18___qxNon {
  padding-bottom: 18px !important;
}

.NoteConfirmationPopup-module__p-b-20___LQyNV {
  padding-bottom: 20px !important;
}

.NoteConfirmationPopup-module__p-b-25___M3jtT {
  padding-bottom: 25px !important;
}

.NoteConfirmationPopup-module__p-b-30___HrU0j {
  padding-bottom: 30px !important;
}

.NoteConfirmationPopup-module__p-b-50___zEyEU {
  padding-bottom: 50px !important;
}

.NoteConfirmationPopup-module__p-t-0___TcWfL {
  padding-top: 0 !important;
}

.NoteConfirmationPopup-module__p-t-12___qt98g {
  padding-top: 12px !important;
}

.NoteConfirmationPopup-module__p-t-16___H5kc8 {
  padding-top: 16px !important;
}

.NoteConfirmationPopup-module__p-t-18___EyuB2 {
  padding-top: 18px !important;
}

.NoteConfirmationPopup-module__p-t-20___nO38d {
  padding-top: 20px !important;
}

.NoteConfirmationPopup-module__p-t-30___YOdZC {
  padding-top: 30px !important;
}

.NoteConfirmationPopup-module__p-t-40___fbVIm {
  padding-top: 40px !important;
}

.NoteConfirmationPopup-module__p-t-50___awZ5F {
  padding-top: 50px !important;
}

.NoteConfirmationPopup-module__p-l-20___cALTR {
  padding-left: 20px !important;
}

.NoteConfirmationPopup-module__p-l-30____uol0 {
  padding-left: 30px !important;
}

.NoteConfirmationPopup-module__p-l-40___TxeR3 {
  padding-left: 40px !important;
}

.NoteConfirmationPopup-module__p-r-16___APcig {
  padding-right: 16px !important;
}

.NoteConfirmationPopup-module__p-r-20___iKgtH {
  padding-right: 20px !important;
}

.NoteConfirmationPopup-module__p-r-30___W5CKJ {
  padding-right: 30px !important;
}

.NoteConfirmationPopup-module__p-r-50___zEguD {
  padding-right: 50px !important;
}

.NoteConfirmationPopup-module__p-r-60___glipw {
  padding-right: 60px !important;
}

.NoteConfirmationPopup-module__m-b-1___ElTf_ {
  margin-bottom: 1px !important;
}

.NoteConfirmationPopup-module__m-b-2___MeWMM {
  margin-bottom: 2px !important;
}

.NoteConfirmationPopup-module__m-b-6___A_1Yx {
  margin-bottom: 6px !important;
}

.NoteConfirmationPopup-module__m-b-8___uBOul {
  margin-bottom: 8px !important;
}

.NoteConfirmationPopup-module__m-b-10___E445i {
  margin-bottom: 10px !important;
}

.NoteConfirmationPopup-module__m-b-14___ZofHV {
  margin-bottom: 14px !important;
}

.NoteConfirmationPopup-module__m-b-16___YgQ7b {
  margin-bottom: 16px !important;
}

.NoteConfirmationPopup-module__m-b-20___Flr8s {
  margin-bottom: 20px !important;
}

.NoteConfirmationPopup-module__m-b-22___x4Z8E {
  margin-bottom: 22px !important;
}

.NoteConfirmationPopup-module__m-b-24___DVTka {
  margin-bottom: 24px !important;
}

.NoteConfirmationPopup-module__m-b-30___JaM_P {
  margin-bottom: 30px !important;
}

.NoteConfirmationPopup-module__m-b-32___njsUH {
  margin-bottom: 32px !important;
}

.NoteConfirmationPopup-module__m-b-40___gFzm5 {
  margin-bottom: 40px !important;
}

.NoteConfirmationPopup-module__m-t-2___kIp_M {
  margin-top: 2px !important;
}

.NoteConfirmationPopup-module__m-t-3___synfJ {
  margin-top: 3px !important;
}

.NoteConfirmationPopup-module__m-t-4___gSyfa {
  margin-top: 4px !important;
}

.NoteConfirmationPopup-module__m-t-5___nM9oA {
  margin-top: 5px !important;
}

.NoteConfirmationPopup-module__m-t-8___idVH0 {
  margin-top: 8px !important;
}

.NoteConfirmationPopup-module__m-t-10___QV86F {
  margin-top: 10px !important;
}

.NoteConfirmationPopup-module__m-t-15___XqxWS {
  margin-top: 15px !important;
}

.NoteConfirmationPopup-module__m-t-16___ewX34 {
  margin-top: 16px !important;
}

.NoteConfirmationPopup-module__m-t-20___EyvoF {
  margin-top: 20px !important;
}

.NoteConfirmationPopup-module__m-t-22___FHtdy {
  margin-top: 22px !important;
}

.NoteConfirmationPopup-module__m-t-30___xCBWR {
  margin-top: 30px !important;
}

.NoteConfirmationPopup-module__m-t-32___VlNlG {
  margin-top: 32px !important;
}

.NoteConfirmationPopup-module__m-l-auto___OYQHE {
  margin-left: auto !important;
}

.NoteConfirmationPopup-module__m-l-4___wXaMh {
  margin-left: 4px !important;
}

.NoteConfirmationPopup-module__m-l-5___wU2TQ {
  margin-left: 5px !important;
}

.NoteConfirmationPopup-module__m-l-6___HJSjT {
  margin-left: 6px !important;
}

.NoteConfirmationPopup-module__m-l-8___S0rlV {
  margin-left: 8px !important;
}

.NoteConfirmationPopup-module__m-l-10___DNp6x {
  margin-left: 10px !important;
}

.NoteConfirmationPopup-module__m-l-16___BQEiw {
  margin-left: 16px !important;
}

.NoteConfirmationPopup-module__m-l-20___QqMUJ {
  margin-left: 20px !important;
}

.NoteConfirmationPopup-module__m-l-24___hYB7c {
  margin-left: 24px !important;
}

.NoteConfirmationPopup-module__m-l-30___DJx7D {
  margin-left: 30px !important;
}

.NoteConfirmationPopup-module__m-l-35___BKZna {
  margin-left: 35px !important;
}

.NoteConfirmationPopup-module__m-l-40___blTUz {
  margin-left: 40px !important;
}

.NoteConfirmationPopup-module__m-r-8___XmEiQ {
  margin-right: 8px !important;
}

.NoteConfirmationPopup-module__m-r-10___GkXUY {
  margin-right: 10px !important;
}

.NoteConfirmationPopup-module__m-r-16___rR3WN {
  margin-right: 16px !important;
}

.NoteConfirmationPopup-module__m-r-20___URTWr {
  margin-right: 20px !important;
}

.NoteConfirmationPopup-module__m-r-24___qzI2j {
  margin-right: 24px !important;
}

.NoteConfirmationPopup-module__m-r-30___e5Hn_ {
  margin-right: 30px !important;
}

.NoteConfirmationPopup-module__m-r-40___Vk1gG {
  margin-right: 40px !important;
}

.NoteConfirmationPopup-module__border-r-3___tRJoQ {
  border-radius: 3px !important;
}

.NoteConfirmationPopup-module__border-r-4___wAjap {
  border-radius: 4px !important;
}

.NoteConfirmationPopup-module__border-r-6___qFOIK {
  border-radius: 6px !important;
}

.NoteConfirmationPopup-module__border-r-10___PKCLc {
  border-radius: 10px !important;
}

.NoteConfirmationPopup-module__border-r-12___f7RRb {
  border-radius: 12px !important;
}

.NoteConfirmationPopup-module__border-r-16___fU4ep {
  border-radius: 16px !important;
}

.NoteConfirmationPopup-module__border-r-50___Fx8Ei {
  border-radius: 50% !important;
}

.NoteConfirmationPopup-module__primary-border___fN1D2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteConfirmationPopup-module__primary-border-b___iaXxy {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteConfirmationPopup-module__primary-border-t___L3tkB {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteConfirmationPopup-module__primary-border-l___v2p5D {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteConfirmationPopup-module__primary-border-r___UW_BN {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.NoteConfirmationPopup-module__secondary-border___uXATJ {
  border: 1px solid #637768;
}

.NoteConfirmationPopup-module__secondary-border-b___MAVDp {
  border-bottom: 1px solid #637768;
}

.NoteConfirmationPopup-module__secondary-border-t___b_0xJ {
  border-top: 1px solid #637768;
}

.NoteConfirmationPopup-module__secondary-border-l___NO3LI {
  border-left: 1px solid #637768;
}

.NoteConfirmationPopup-module__secondary-border-r___tOA56 {
  border-right: 1px solid #637768;
}

.NoteConfirmationPopup-module__gap-0____Sb9b {
  gap: 0 !important;
}

.NoteConfirmationPopup-module__gap-2___n1qT2 {
  gap: 2px !important;
}

.NoteConfirmationPopup-module__gap-4___KRPuT {
  gap: 4px !important;
}

.NoteConfirmationPopup-module__gap-5___zGi82 {
  gap: 5px !important;
}

.NoteConfirmationPopup-module__gap-6___Y5MTo {
  gap: 6px !important;
}

.NoteConfirmationPopup-module__gap-8___s2SS7 {
  gap: 8px !important;
}

.NoteConfirmationPopup-module__gap-10___CAvwk {
  gap: 10px !important;
}

.NoteConfirmationPopup-module__gap-12___htM2o {
  gap: 12px !important;
}

.NoteConfirmationPopup-module__gap-14___pj31q {
  gap: 14px !important;
}

.NoteConfirmationPopup-module__gap-16___qyZLe {
  gap: 16px !important;
}

.NoteConfirmationPopup-module__gap-18___KpSQo {
  gap: 18px !important;
}

.NoteConfirmationPopup-module__gap-20____EVp5 {
  gap: 20px !important;
}

.NoteConfirmationPopup-module__gap-24___eBjOC {
  gap: 24px !important;
}

.NoteConfirmationPopup-module__gap-26___zPb8E {
  gap: 26px !important;
}

.NoteConfirmationPopup-module__gap-30___lPjSY {
  gap: 30px !important;
}

.NoteConfirmationPopup-module__gap-32___U48h5 {
  gap: 32px !important;
}

.NoteConfirmationPopup-module__gap-40___fWD31 {
  gap: 40px !important;
}

.NoteConfirmationPopup-module__gap-50___nwMwt {
  gap: 50px !important;
}

.NoteConfirmationPopup-module__flex-1___CIiYd {
  flex: 1;
}

.NoteConfirmationPopup-module__flex-none___UBhsh {
  flex: none !important;
}

.NoteConfirmationPopup-module__flex-column___LmKIw {
  display: flex;
  flex-direction: column !important;
}

.NoteConfirmationPopup-module__flex-row___VTr1D {
  display: flex;
  flex-direction: row !important;
}

.NoteConfirmationPopup-module__vertically-centered____0gmF {
  display: flex;
  align-items: center !important;
}

.NoteConfirmationPopup-module__horizontally-centered___Sxexw {
  display: flex;
  justify-content: center !important;
}

.NoteConfirmationPopup-module__horizontally-end___ObW19 {
  display: flex;
  justify-content: end !important;
}

.NoteConfirmationPopup-module__vertically-start___aZz_U {
  display: flex;
  align-items: start !important;
}

.NoteConfirmationPopup-module__space-between___Qm3L1 {
  display: flex;
  justify-content: space-between !important;
}

.NoteConfirmationPopup-module__flex-wrap___ahic_ {
  flex-wrap: wrap !important;
}

.NoteConfirmationPopup-module__height-100___VEHLN {
  height: 100%;
}

.NoteConfirmationPopup-module__width-50___FFOy4 {
  width: 50% !important;
}

.NoteConfirmationPopup-module__width-100___LKKiK {
  width: 100%;
}

.NoteConfirmationPopup-module__cursor-pointer___jRkdv {
  cursor: pointer;
}

.NoteConfirmationPopup-module__cursor-not-allowed____QHlb {
  cursor: not-allowed !important;
}

.NoteConfirmationPopup-module__absolute-centered___eiuYb {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.NoteConfirmationPopup-module__absolute___f8kTU {
  position: absolute;
}

.NoteConfirmationPopup-module__relative___XTs4F {
  position: relative;
}

.NoteConfirmationPopup-module__fixed___K6wyO {
  position: fixed;
}

.NoteConfirmationPopup-module__visible___UeHXN {
  opacity: 1;
}

.NoteConfirmationPopup-module__invisible___saV3W {
  opacity: 0;
}

.NoteConfirmationPopup-module__col-90___GA9bb {
  width: 90% !important;
}

.NoteConfirmationPopup-module__col-auto___nCrkA {
  width: auto !important;
}

.NoteConfirmationPopup-module__medical-tabs___dP1mN {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.NoteConfirmationPopup-module__medical-table-new___YYmBg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg::-webkit-scrollbar-track {
  display: none;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg.NoteConfirmationPopup-module__no-pagination___EnAPZ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg.NoteConfirmationPopup-module__no-pagination___EnAPZ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg.NoteConfirmationPopup-module__no-pagination___EnAPZ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.NoteConfirmationPopup-module__medical-table-new___YYmBg.NoteConfirmationPopup-module__no-pagination___EnAPZ::-webkit-scrollbar-track {
  display: none;
}

.NoteConfirmationPopup-module__medical-table-empty___tpvUB {
  padding: 14px 40px !important;
}

.NoteConfirmationPopup-module__icon-btn___ua_Of {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.NoteConfirmationPopup-module__search-icon___MYgXD {
  width: 24px;
  height: 24px;
  align-self: center;
}

.NoteConfirmationPopup-module__disable-select___RuZVG {
  user-select: none;
}

.NoteConfirmationPopup-module__break-word___V110n {
  word-break: break-word;
}

.NoteConfirmationPopup-module__popup-clear-btn___nv5xy {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.NoteConfirmationPopup-module__scroll-m-b-20___igr2I {
  scroll-margin-bottom: 20px;
}

.NoteConfirmationPopup-module__container___iggG6 {
  display: flex;
  flex-direction: column;
  padding: 20px 41px 10px 41px;
  align-items: center;
}
.NoteConfirmationPopup-module__container___iggG6 .NoteConfirmationPopup-module__radioItem___qgYgm {
  width: 100%;
  padding: 10px;
  border: 1px solid #859989;
  border-radius: 6px;
  margin-bottom: 10px !important;
}

.NoteConfirmationPopup-module__buttonsContainer___Otq9r {
  justify-content: end;
  margin: 0 auto 30px auto;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/NoteConfirmationPopup/NoteConfirmationPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AA8pBJ;;AA1pBA;EACE,oBAAA;EACA,wBAAA;EACA,aAAA;EACA,SAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 41px 10px 41px;\n  align-items: center;\n\n  .radioItem {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid get-color(greenNew, medium);\n    border-radius: 6px;\n    margin-bottom: 10px !important;\n  }\n}\n\n.buttonsContainer {\n  justify-content: end;\n  margin: 0 auto 30px auto;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `NoteConfirmationPopup-module__font-s-10___DJFim`,
	"fontS12": `NoteConfirmationPopup-module__font-s-12___zZ0g5`,
	"fontS13": `NoteConfirmationPopup-module__font-s-13___iAgV3`,
	"fontS14": `NoteConfirmationPopup-module__font-s-14___pG2vN`,
	"fontS15": `NoteConfirmationPopup-module__font-s-15___e358v`,
	"fontS16": `NoteConfirmationPopup-module__font-s-16___vIOZv`,
	"fontS18": `NoteConfirmationPopup-module__font-s-18___A4wXA`,
	"fontS20": `NoteConfirmationPopup-module__font-s-20___MTjkC`,
	"fontS22": `NoteConfirmationPopup-module__font-s-22___Nzspu`,
	"fontS28": `NoteConfirmationPopup-module__font-s-28___XsexU`,
	"fontW400": `NoteConfirmationPopup-module__font-w-400___s3eM4`,
	"fontW500": `NoteConfirmationPopup-module__font-w-500___DbAqx`,
	"fontW600": `NoteConfirmationPopup-module__font-w-600___Dobj8`,
	"fontW700": `NoteConfirmationPopup-module__font-w-700___w2HvD`,
	"p5": `NoteConfirmationPopup-module__p-5___KFu5d`,
	"p12": `NoteConfirmationPopup-module__p-12___TrLT_`,
	"p16": `NoteConfirmationPopup-module__p-16___9PbBY`,
	"p30": `NoteConfirmationPopup-module__p-30___HDPLW`,
	"pB0": `NoteConfirmationPopup-module__p-b-0___i9aic`,
	"pB5": `NoteConfirmationPopup-module__p-b-5___KWYM4`,
	"pB10": `NoteConfirmationPopup-module__p-b-10___SXh2Y`,
	"pB12": `NoteConfirmationPopup-module__p-b-12___Ny8Kn`,
	"pB16": `NoteConfirmationPopup-module__p-b-16___bowux`,
	"pB18": `NoteConfirmationPopup-module__p-b-18___qxNon`,
	"pB20": `NoteConfirmationPopup-module__p-b-20___LQyNV`,
	"pB25": `NoteConfirmationPopup-module__p-b-25___M3jtT`,
	"pB30": `NoteConfirmationPopup-module__p-b-30___HrU0j`,
	"pB50": `NoteConfirmationPopup-module__p-b-50___zEyEU`,
	"pT0": `NoteConfirmationPopup-module__p-t-0___TcWfL`,
	"pT12": `NoteConfirmationPopup-module__p-t-12___qt98g`,
	"pT16": `NoteConfirmationPopup-module__p-t-16___H5kc8`,
	"pT18": `NoteConfirmationPopup-module__p-t-18___EyuB2`,
	"pT20": `NoteConfirmationPopup-module__p-t-20___nO38d`,
	"pT30": `NoteConfirmationPopup-module__p-t-30___YOdZC`,
	"pT40": `NoteConfirmationPopup-module__p-t-40___fbVIm`,
	"pT50": `NoteConfirmationPopup-module__p-t-50___awZ5F`,
	"pL20": `NoteConfirmationPopup-module__p-l-20___cALTR`,
	"pL30": `NoteConfirmationPopup-module__p-l-30____uol0`,
	"pL40": `NoteConfirmationPopup-module__p-l-40___TxeR3`,
	"pR16": `NoteConfirmationPopup-module__p-r-16___APcig`,
	"pR20": `NoteConfirmationPopup-module__p-r-20___iKgtH`,
	"pR30": `NoteConfirmationPopup-module__p-r-30___W5CKJ`,
	"pR50": `NoteConfirmationPopup-module__p-r-50___zEguD`,
	"pR60": `NoteConfirmationPopup-module__p-r-60___glipw`,
	"mB1": `NoteConfirmationPopup-module__m-b-1___ElTf_`,
	"mB2": `NoteConfirmationPopup-module__m-b-2___MeWMM`,
	"mB6": `NoteConfirmationPopup-module__m-b-6___A_1Yx`,
	"mB8": `NoteConfirmationPopup-module__m-b-8___uBOul`,
	"mB10": `NoteConfirmationPopup-module__m-b-10___E445i`,
	"mB14": `NoteConfirmationPopup-module__m-b-14___ZofHV`,
	"mB16": `NoteConfirmationPopup-module__m-b-16___YgQ7b`,
	"mB20": `NoteConfirmationPopup-module__m-b-20___Flr8s`,
	"mB22": `NoteConfirmationPopup-module__m-b-22___x4Z8E`,
	"mB24": `NoteConfirmationPopup-module__m-b-24___DVTka`,
	"mB30": `NoteConfirmationPopup-module__m-b-30___JaM_P`,
	"mB32": `NoteConfirmationPopup-module__m-b-32___njsUH`,
	"mB40": `NoteConfirmationPopup-module__m-b-40___gFzm5`,
	"mT2": `NoteConfirmationPopup-module__m-t-2___kIp_M`,
	"mT3": `NoteConfirmationPopup-module__m-t-3___synfJ`,
	"mT4": `NoteConfirmationPopup-module__m-t-4___gSyfa`,
	"mT5": `NoteConfirmationPopup-module__m-t-5___nM9oA`,
	"mT8": `NoteConfirmationPopup-module__m-t-8___idVH0`,
	"mT10": `NoteConfirmationPopup-module__m-t-10___QV86F`,
	"mT15": `NoteConfirmationPopup-module__m-t-15___XqxWS`,
	"mT16": `NoteConfirmationPopup-module__m-t-16___ewX34`,
	"mT20": `NoteConfirmationPopup-module__m-t-20___EyvoF`,
	"mT22": `NoteConfirmationPopup-module__m-t-22___FHtdy`,
	"mT30": `NoteConfirmationPopup-module__m-t-30___xCBWR`,
	"mT32": `NoteConfirmationPopup-module__m-t-32___VlNlG`,
	"mLAuto": `NoteConfirmationPopup-module__m-l-auto___OYQHE`,
	"mL4": `NoteConfirmationPopup-module__m-l-4___wXaMh`,
	"mL5": `NoteConfirmationPopup-module__m-l-5___wU2TQ`,
	"mL6": `NoteConfirmationPopup-module__m-l-6___HJSjT`,
	"mL8": `NoteConfirmationPopup-module__m-l-8___S0rlV`,
	"mL10": `NoteConfirmationPopup-module__m-l-10___DNp6x`,
	"mL16": `NoteConfirmationPopup-module__m-l-16___BQEiw`,
	"mL20": `NoteConfirmationPopup-module__m-l-20___QqMUJ`,
	"mL24": `NoteConfirmationPopup-module__m-l-24___hYB7c`,
	"mL30": `NoteConfirmationPopup-module__m-l-30___DJx7D`,
	"mL35": `NoteConfirmationPopup-module__m-l-35___BKZna`,
	"mL40": `NoteConfirmationPopup-module__m-l-40___blTUz`,
	"mR8": `NoteConfirmationPopup-module__m-r-8___XmEiQ`,
	"mR10": `NoteConfirmationPopup-module__m-r-10___GkXUY`,
	"mR16": `NoteConfirmationPopup-module__m-r-16___rR3WN`,
	"mR20": `NoteConfirmationPopup-module__m-r-20___URTWr`,
	"mR24": `NoteConfirmationPopup-module__m-r-24___qzI2j`,
	"mR30": `NoteConfirmationPopup-module__m-r-30___e5Hn_`,
	"mR40": `NoteConfirmationPopup-module__m-r-40___Vk1gG`,
	"borderR3": `NoteConfirmationPopup-module__border-r-3___tRJoQ`,
	"borderR4": `NoteConfirmationPopup-module__border-r-4___wAjap`,
	"borderR6": `NoteConfirmationPopup-module__border-r-6___qFOIK`,
	"borderR10": `NoteConfirmationPopup-module__border-r-10___PKCLc`,
	"borderR12": `NoteConfirmationPopup-module__border-r-12___f7RRb`,
	"borderR16": `NoteConfirmationPopup-module__border-r-16___fU4ep`,
	"borderR50": `NoteConfirmationPopup-module__border-r-50___Fx8Ei`,
	"primaryBorder": `NoteConfirmationPopup-module__primary-border___fN1D2`,
	"primaryBorderB": `NoteConfirmationPopup-module__primary-border-b___iaXxy`,
	"primaryBorderT": `NoteConfirmationPopup-module__primary-border-t___L3tkB`,
	"primaryBorderL": `NoteConfirmationPopup-module__primary-border-l___v2p5D`,
	"primaryBorderR": `NoteConfirmationPopup-module__primary-border-r___UW_BN`,
	"secondaryBorder": `NoteConfirmationPopup-module__secondary-border___uXATJ`,
	"secondaryBorderB": `NoteConfirmationPopup-module__secondary-border-b___MAVDp`,
	"secondaryBorderT": `NoteConfirmationPopup-module__secondary-border-t___b_0xJ`,
	"secondaryBorderL": `NoteConfirmationPopup-module__secondary-border-l___NO3LI`,
	"secondaryBorderR": `NoteConfirmationPopup-module__secondary-border-r___tOA56`,
	"gap0": `NoteConfirmationPopup-module__gap-0____Sb9b`,
	"gap2": `NoteConfirmationPopup-module__gap-2___n1qT2`,
	"gap4": `NoteConfirmationPopup-module__gap-4___KRPuT`,
	"gap5": `NoteConfirmationPopup-module__gap-5___zGi82`,
	"gap6": `NoteConfirmationPopup-module__gap-6___Y5MTo`,
	"gap8": `NoteConfirmationPopup-module__gap-8___s2SS7`,
	"gap10": `NoteConfirmationPopup-module__gap-10___CAvwk`,
	"gap12": `NoteConfirmationPopup-module__gap-12___htM2o`,
	"gap14": `NoteConfirmationPopup-module__gap-14___pj31q`,
	"gap16": `NoteConfirmationPopup-module__gap-16___qyZLe`,
	"gap18": `NoteConfirmationPopup-module__gap-18___KpSQo`,
	"gap20": `NoteConfirmationPopup-module__gap-20____EVp5`,
	"gap24": `NoteConfirmationPopup-module__gap-24___eBjOC`,
	"gap26": `NoteConfirmationPopup-module__gap-26___zPb8E`,
	"gap30": `NoteConfirmationPopup-module__gap-30___lPjSY`,
	"gap32": `NoteConfirmationPopup-module__gap-32___U48h5`,
	"gap40": `NoteConfirmationPopup-module__gap-40___fWD31`,
	"gap50": `NoteConfirmationPopup-module__gap-50___nwMwt`,
	"flex1": `NoteConfirmationPopup-module__flex-1___CIiYd`,
	"flexNone": `NoteConfirmationPopup-module__flex-none___UBhsh`,
	"flexColumn": `NoteConfirmationPopup-module__flex-column___LmKIw`,
	"flexRow": `NoteConfirmationPopup-module__flex-row___VTr1D`,
	"verticallyCentered": `NoteConfirmationPopup-module__vertically-centered____0gmF`,
	"horizontallyCentered": `NoteConfirmationPopup-module__horizontally-centered___Sxexw`,
	"horizontallyEnd": `NoteConfirmationPopup-module__horizontally-end___ObW19`,
	"verticallyStart": `NoteConfirmationPopup-module__vertically-start___aZz_U`,
	"spaceBetween": `NoteConfirmationPopup-module__space-between___Qm3L1`,
	"flexWrap": `NoteConfirmationPopup-module__flex-wrap___ahic_`,
	"height100": `NoteConfirmationPopup-module__height-100___VEHLN`,
	"width50": `NoteConfirmationPopup-module__width-50___FFOy4`,
	"width100": `NoteConfirmationPopup-module__width-100___LKKiK`,
	"cursorPointer": `NoteConfirmationPopup-module__cursor-pointer___jRkdv`,
	"cursorNotAllowed": `NoteConfirmationPopup-module__cursor-not-allowed____QHlb`,
	"absoluteCentered": `NoteConfirmationPopup-module__absolute-centered___eiuYb`,
	"absolute": `NoteConfirmationPopup-module__absolute___f8kTU`,
	"relative": `NoteConfirmationPopup-module__relative___XTs4F`,
	"fixed": `NoteConfirmationPopup-module__fixed___K6wyO`,
	"visible": `NoteConfirmationPopup-module__visible___UeHXN`,
	"invisible": `NoteConfirmationPopup-module__invisible___saV3W`,
	"col90": `NoteConfirmationPopup-module__col-90___GA9bb`,
	"colAuto": `NoteConfirmationPopup-module__col-auto___nCrkA`,
	"medicalTabs": `NoteConfirmationPopup-module__medical-tabs___dP1mN`,
	"medicalTableNew": `NoteConfirmationPopup-module__medical-table-new___YYmBg`,
	"noPagination": `NoteConfirmationPopup-module__no-pagination___EnAPZ`,
	"medicalTableEmpty": `NoteConfirmationPopup-module__medical-table-empty___tpvUB`,
	"iconBtn": `NoteConfirmationPopup-module__icon-btn___ua_Of`,
	"searchIcon": `NoteConfirmationPopup-module__search-icon___MYgXD`,
	"disableSelect": `NoteConfirmationPopup-module__disable-select___RuZVG`,
	"breakWord": `NoteConfirmationPopup-module__break-word___V110n`,
	"popupClearBtn": `NoteConfirmationPopup-module__popup-clear-btn___nv5xy`,
	"scrollMB20": `NoteConfirmationPopup-module__scroll-m-b-20___igr2I`,
	"container": `NoteConfirmationPopup-module__container___iggG6`,
	"radioItem": `NoteConfirmationPopup-module__radioItem___qgYgm`,
	"buttonsContainer": `NoteConfirmationPopup-module__buttonsContainer___Otq9r`
};
module.exports = ___CSS_LOADER_EXPORT___;
